<script lang="ts">
	import { getProductPath } from "../../../../core/schema/paths/getProductPath.js";
	import { OrderStatus } from "../../../../core/schema/OrderStatus.js";
	import { nbspify } from "../../../../core/utils/nbspify.js";
	import { formatPrice } from "../../../../core/utils/formatPrice.js";
	import cake from "../../../../core/assets/icons/cake.svg?raw";
	import Button from "../Button.svelte";
	import ProductImageWithCounter from "./ProductImageWithCounter.svelte";
	import { getGlobalSettings } from "../../getGlobalSettings.js";
	import OrderProductCardOptions from "./OrderProductCardOptions.svelte";
	import logo from "../../../../core/assets/logo.png";
	import type { ProductForCustomer } from "../../../../core/schema/Product.js";
	import { getImagesForProduct } from "../../../../core/schema/utils/getImagesForProduct.js";
	import type { OrderProductForCustomer } from "../../../../core/schema/public/OrderProductForCustomer.js";
	import { getPriceOfOrderProduct } from "../../../../core/schema/utils/getPriceOfOrderProduct.js";

	export let product: ProductForCustomer;
	export let orderProduct: OrderProductForCustomer;
	export let orderStatus: OrderStatus;
	export let onRepeatOrder: (() => Promise<void>) | undefined = undefined;
	export let isAlone: boolean;
	export let isLast: boolean;

	const globalSettings = getGlobalSettings();
	const { TENANT_LOCALE } = globalSettings;

	$: showRepeat = [OrderStatus.Delivered, OrderStatus.Cancelled].includes(orderStatus) && isLast && onRepeatOrder;
	$: [image] = getImagesForProduct(product, orderProduct.size);
	$: price = getPriceOfOrderProduct(orderProduct);
</script>

<div class="border-t-1 flex w-full flex-col justify-between gap-4 border-gray-200 p-4 md:p-6 lg:flex-row">
	<div class="flex flex-col gap-4 lg:flex-row">
		<div class="flex gap-2 md:gap-4">
			<ProductImageWithCounter
				image={image ?? logo}
				size={88}
				imgClass="min-w-[3.5rem] md:min-w-[5.5rem] md:w-[5.5rem] w-[3.5rem] md:h-[5.5rem] h-[3.5rem] object-contain"
				path={getProductPath(TENANT_LOCALE, orderProduct.product)}
				quantity={orderProduct.quantity}
			/>
			<p class="md:text-md self-start text-base font-semibold lg:hidden">{orderProduct.product.name[TENANT_LOCALE]}</p>
		</div>
		<div class="flex flex-col justify-between gap-3">
			<p class="text-md hidden self-start font-semibold lg:inline">
				{orderProduct.product.name[TENANT_LOCALE]}
			</p>
			<OrderProductCardOptions {orderStatus} {product} {orderProduct} {isAlone} />
		</div>
	</div>

	<div class="flex flex-col items-end justify-between">
		{#if !isAlone}
			<p class="text-md font-semibold">
				{nbspify(formatPrice(price.withTax, TENANT_LOCALE, false))}
			</p>
		{/if}
		{#if showRepeat}
			<div class="mt-auto hidden self-end text-nowrap lg:block">
				<Button variant="primary" icon={cake} iconClass="h-5 w-5" on:click={onRepeatOrder}>Znovu objednat</Button>
			</div>
		{/if}
	</div>
</div>
{#if showRepeat}
	<div class="border-t-1 flex w-full justify-center border-gray-200 py-4 lg:hidden">
		<Button variant="primary" icon={cake} iconClass="h-5 w-5" on:click={onRepeatOrder}>Znovu objednat</Button>
	</div>
{/if}
